"use client";

import Modal from "@/components/ui/modal";
import ContactUs from "./contact-us";

type TContactUsModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const ContactUsModal = ({ isOpen, onClose }: TContactUsModalProps) => {
	return (
		<Modal title="" isOpen={isOpen} onClose={onClose} className="max-w-xl px-8 py-6">
			<ContactUs showPressReleaseMarketing={false} />
		</Modal>
	);
};

export default ContactUsModal;
